export default {
    event_delete_title: "Eliminar evento",
    event_delete_success_message: "Se ha eliminado el evento",
    event_delete_message: "¿Estás seguro de que quieres eliminar el evento?",
}